import React, { useState } from 'react';
import { Collapse, Button } from 'reactstrap';
import classnames from 'classnames';

import { TriStateSwitch } from 'js/components/Forms/TriStateSwitch';
import {
  SELECTION,
  questionId,
  questionSetIds,
  selectionState,
} from 'js/utils/question-selection';

const ConfigureQuestionSet = ({
  tag: Tag,
  questionSet,
  setIndex,
  defaultOpen,
  excluded,
  categoryReference,
  onToggle,
  className,
  ...attributes
}) => {
  const [showQuestions, setShowQuestions] = useState(defaultOpen);

  const ids = questionSetIds(questionSet, setIndex);
  const state = selectionState(ids, excluded);
  const removed = state === SELECTION.OFF;
  const includedCount = ids.filter((id) => !excluded.has(id)).length;

  const category = questionSet.category || 'uncategorized';
  const myCategoryReference = categoryReference[category];

  const toggleShowQuestions = (e) => {
    e.preventDefault();

    setShowQuestions(!showQuestions);
  };

  return (
    <Tag
      className={classnames('question-set', className, { removed })}
      {...attributes}
    >
      <div
        className={classnames({ 'question-set-header': true, muted: removed })}
      >
        <div className="question-count">
          {includedCount === ids.length
            ? `${ids.length} questions`
            : `${includedCount} of ${ids.length} questions`}{' '}
          <br />(
          <Button
            color="link"
            onClick={toggleShowQuestions}
            aria-expanded={showQuestions}
          >
            {showQuestions ? 'hide' : 'show'}
          </Button>
          )
        </div>
        <div className="question-set-categories">
          <span
            className={`question-set-category ${myCategoryReference.paletteClass}`}
          >
            {myCategoryReference.display_name}
          </span>
        </div>
        <TriStateSwitch
          id={`question-set-filter-${setIndex}`}
          state={state}
          onChange={() => onToggle(ids)}
          className="question-set-switch"
          label={<h5 className="question-set-name">{questionSet.name}</h5>}
        />
      </div>
      <Collapse isOpen={showQuestions}>
        <ul className="questions">
          {questionSet.questions.map((q, questionIndex) => {
            const id = questionId(setIndex, questionIndex);
            const included = !excluded.has(id);

            return (
              <li
                className={classnames('question', { removed: !included })}
                key={id}
              >
                <TriStateSwitch
                  id={`question-filter-${id.replace(':', '-')}`}
                  state={included ? SELECTION.ON : SELECTION.OFF}
                  onChange={() => onToggle([id])}
                  size="sm"
                  label={q.text}
                />
              </li>
            );
          })}
        </ul>
      </Collapse>
    </Tag>
  );
};

ConfigureQuestionSet.defaultProps = {
  tag: 'div',
  className: null,
  defaultOpen: false,
  onToggle: () => {},
};

export default ConfigureQuestionSet;
